module.exports = __webpack_public_path__ + "static/media/Societe-Transformation-Immobiliere-Vaud.e8fedf9b.jpg";